module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Checkout"
  }, [_c('div', {
    staticClass: "Checkout-Section Left"
  }, [_c('FormList'), _vm._v(" "), _c('back-button', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'List',
          params: {
            module_id: _vm.active_module.module_id,
            scrollParent: true
          }
        })
      }
    }
  }, [_c('p', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t('checkout.title_back_description')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "Checkout-Section right"
  }, [_c('SummaryView'), _vm._v(" "), _c('PaymentList', {
    attrs: {
      "currency": _vm.active_module.currency,
      "total": _vm.amount_with_modifiers_normal_after_coupon || _vm.amount_with_modifiers_normal,
      "total_partial": _vm.amount_with_modifiers_partial_after_coupon || _vm.amount_with_modifiers_partial,
      "gateways": _vm.active_module.gateways,
      "active_gateway": _vm.active_gateway,
      "error_code": _vm.decodeMessage,
      "selected_partial": _vm.selected_partial
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-459362c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/Checkout.vue
// module id = 253
// module chunks = 1